<template>
  <div></div>
</template>

<script>
  export default {
    name: 'HelloWorld',
    data() {
      return {
        intervalId: null,
      }
    },
    mounted() {
      console.log(222)
      this.checkUpdateInterval()
    },
    unmounted() {
      clearInterval(this.intervalId)
    },
    methods: {
      checkUpdate(url, isFirst = false) {
        const _this = this
        return new Promise((resolve, reject) => {
          fetch(url).then(response => {
            // 检查响应状态
            if (response.ok) {
              // 获取Last-Modified响应头
              const lastModified = response.headers.get('Last-Modified')
              if (lastModified) {
                console.log('Last-Modified:', lastModified)
                if (isFirst) {
                  localStorage.setItem('lastModifiedWebpage', lastModified)
                  resolve(true)
                  true
                }
                const lastModifiedStorageTime = localStorage.getItem('lastModifiedWebpage')
                try {
                  if (lastModifiedStorageTime) {
                    const isNeedShowUpdateModal =
                      new Date(lastModified).getTime() > new Date(lastModifiedStorageTime).getTime()
                    if (isNeedShowUpdateModal) _this.open()
                  }
                } catch (e) {
                  console.log(e || '系统更新错误')
                }
              } else {
                console.log('Last-Modified header not found')
              }
              resolve(true)
            } else {
              reject(false)
              throw new Error('Network response was not ok.')
            }
          })
        })
      },

      async checkUpdateInterval() {
        const url = location.origin + '/webpage/#/OrderSearch'
        const _this = this
        // const url = 'http://sfkc-tms.sf-express.com/webpage/#/OrderSearch'
        await _this.checkUpdate(url, true)
        this.intervalId = setInterval(() => {
          _this.checkUpdate(url)
        }, 1000 * 60 * 30)
      },
      open() {
        this.$alert('系统存在更新，是否更新', '', {
          confirmButtonText: '确定',
          callback: () => {
            location.reload()
          },
        })
      },
    },
  }
</script>
